module.exports = __webpack_public_path__ + "img/brand-icon-active.6cc7a016.svg";